import React from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy, faSlidersH } from '@fortawesome/pro-light-svg-icons'

import { Button, Tools } from '@domain-group/suit-theme'

import useService from '@hooks/useService'

const ServiceProductTools = (props) => {
  const { callbacks, service } = props
  const { launchDuplicateServiceProductModal, manageServiceProductTaskOptions } = callbacks || {}

  const {
    isTaskable,
  } = useService(service)

  return (
    <Tools>
      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={faCopy} />}
        onClick={() => launchDuplicateServiceProductModal()}
        size="medium"
      >
        Duplicate Product
      </Button>

      {isTaskable && (
        <Button
          buttonStyle="secondaryUtility"
          icon={<FontAwesomeIcon icon={faSlidersH} />}
          marginTop="medium"
          onClick={() => manageServiceProductTaskOptions()}
          size="medium"
        >
          Task Settings
        </Button>
      )}
    </Tools>
  )
}

ServiceProductTools.propTypes = {
  callbacks: PropTypes.object.isRequired,
  service: PropTypes.object.isRequired,
}

export default ServiceProductTools
